/* @flow */
import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button
} from 'reactstrap'
import Quotes from '../Quotes'

import {
  Close,
  SmallCheck
} from '../Icons'

import { isApp } from '../../helpers/nativeApp'

import './Modal.css'

// In the phone app nothing is sold (App Store and Google Play rules): Pro is
// bought on gymradio.com, and the app only says where it is managed.
const subscribeAction = (onSubmit) => {
  if (isApp()) {
    return (
      <p className="modal__pro-note">Pro is managed in your GymRadio.com account.</p>
    )
  }
  return (
    <div className="modal_buttonGroup">
      <Button color="primary" onClick={ onSubmit } size="lg">
        <strong>Subscribe now</strong>
      </Button>
    </div>
  )
}

const getPros = () => {
  return (
    <div className="modal__content">
      <ul>
        <li><SmallCheck /> <span className="modal__list_content">All music stations</span></li>
        <li><SmallCheck /> <span className="modal__list_content">Daily music updates</span></li>
        <li><SmallCheck /> <span className="modal__list_content">Audio promotions to boost sales</span></li>
        <li><SmallCheck /> <span className="modal__list_content">Legal and compliant music</span></li>
      </ul>
      <ul>
        <li><SmallCheck /> <span className="modal__list_content">High-quality curated music</span></li>
        <li><SmallCheck /> <span className="modal__list_content">Explicit and Soft-explicit filters</span></li>
        <li><SmallCheck /> <span className="modal__list_content">Dislike song button</span></li>
        <li><SmallCheck /> <span className="modal__list_content">Branded motivational quotes to keep members motivated</span></li>
      </ul>
    </div>
  )
}

export const AudioMessageModal = observer(class AudioMessageModal extends Component {
  render () {
    const {
      isOpen,
      quotes,
      onMotivationalMessagesStatusChanged,
      onPromotionalMessagesStatusChanged,
      onCancel
    } = this.props
    return (
      <div>
        <Modal isOpen={ isOpen } toggle={ onCancel } className={this.props.className}>
          <div onClick={ onCancel } className="modal__close">
            <Close />
          </div>
          <ModalHeader>
            Audio Promotions
          </ModalHeader>
          <ModalBody>
            <Quotes
              quotes={ quotes }
              onMotivationalMessagesStatusChanged={ onMotivationalMessagesStatusChanged }
              onPromotionalMessagesStatusChanged={ onPromotionalMessagesStatusChanged }
              onToggle={ this.onToggle }
            />
          </ModalBody>
        </Modal>
      </div>
    )
  }
})

export const SignUpModal = inject((stores) => ({
  userStore: stores.userStore
}))(
  observer(class SignUpModal extends Component {
    constructor (props) {
      super(props)
      this.login = this.login.bind(this)
      this.signUp = this.signUp.bind(this)
    }

    login () {
      this.props.userStore.login()
    }

    signUp () {
      this.props.userStore.login('', true)
    }

    render() {
      const {
        isOpen,
        onCancel
      } = this.props
      return (
        <div>
          <Modal isOpen={ isOpen } toggle={ onCancel } className={this.props.className}>
            <div onClick={ onCancel } className="modal__close">
              <Close />
            </div>
            <ModalHeader>
              Signup and try Pro<strong>14 days for free</strong>
            </ModalHeader>
            <ModalBody>
              { getPros() }
              <div className="modal_buttonGroup">
                <Button color="primary" onClick={ this.signUp } size="lg">
                  <strong>Sign up</strong>
                </Button>
                <div onClick={ this.login } className="btn__link">
                  Login
                </div>
              </div>
              <p>No credit card required. After the 14 days, free accounts get 5 minutes of music per hour.
              </p>
              <p>
                By signing up, you agree to <a
                  href="http://gymradio.com/termsofuse.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >Terms of Service</a>
              </p>
            </ModalBody>
          </Modal>
        </div>
      )
    }
  })
)

export class PremiumModal extends Component {
  render() {
    const {
      isOpen,
      onSubmit,
      onCancel
    } = this.props
    return (
      <div>
        <Modal isOpen={ isOpen } toggle={ onCancel } className={this.props.className}>
          <div onClick={ onCancel } className="modal__close">
            <Close />
          </div>
          <ModalHeader>
            <strong>GymRadio.com Pro</strong> unlocks every feature
          </ModalHeader>
          <ModalBody>
            { this.props.trialEnded && (
              <p>Your 14-day Pro trial has ended. Subscribe to unlock every station and feature again.</p>
            ) }
            { getPros() }
            { subscribeAction(onSubmit) }
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

export class FreeSlotModal extends Component {
  render() {
    const {
      isOpen,
      onSubmit,
      onCancel,
      freeMinutes = 5,
      resetIn
    } = this.props
    return (
      <div>
        <Modal isOpen={ isOpen } toggle={ onCancel } className={this.props.className}>
          <div onClick={ onCancel } className="modal__close">
            <Close />
          </div>
          <ModalHeader>
            Your free music <strong>is used up for this hour</strong>
          </ModalHeader>
          <ModalBody>
            <p>
              Your 14-day Pro trial has ended. Free accounts get { freeMinutes } minutes of music per hour
              { resetIn ? <span>, and your next { freeMinutes } minutes unlock in <strong>{ resetIn }</strong></span> : null }.
            </p>
            <p>
              Subscribe to GymRadio.com Pro for non-stop music, every station and all features.
            </p>
            { getPros() }
            { subscribeAction(onSubmit) }
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

// Delete my account (required by the App Store and Google Play). A paying gym
// cancels its subscription first, so nobody keeps being billed for a deleted login.
export class DeleteAccountModal extends Component {
  render() {
    const { isOpen, onCancel, onConfirm, email, hasSubscription, busy, error, done } = this.props
    return (
      <div>
        <Modal isOpen={ isOpen } toggle={ busy ? undefined : onCancel } className={this.props.className}>
          { !busy && (
            <div onClick={ onCancel } className="modal__close">
              <Close />
            </div>
          ) }
          <ModalHeader>
            Delete <strong>my account</strong>
          </ModalHeader>
          <ModalBody>
            { done ? (
              <p>Your account has been deleted. Thanks for trying GymRadio.com.</p>
            ) : hasSubscription ? (
              <div>
                <p>
                  Your GymRadio.com Pro subscription is still active, so this account can't be deleted yet.
                </p>
                <p>
                  Cancel the subscription first from your billing page on gymradio.com, or email
                  support@gymradio.com, and then delete the account here.
                </p>
              </div>
            ) : (
              <div>
                <p>
                  This permanently deletes the login <strong>{ email }</strong>, its settings, ads and
                  class announcements. It can't be undone.
                </p>
                <p>
                  Any remaining free trial is lost. You can sign up again later with a new trial only if
                  you use a different email address.
                </p>
                { error && <p className="modal__error">{ error }</p> }
                <div className="modal_buttonGroup">
                  <Button color="danger" onClick={ onConfirm } size="lg" disabled={ busy }>
                    <strong>{ busy ? 'Deleting…' : 'Delete my account' }</strong>
                  </Button>
                  <div onClick={ busy ? undefined : onCancel } className="btn__link">
                    Keep my account
                  </div>
                </div>
              </div>
            ) }
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

// Shown when the same account has signed in on another device (newest login wins).
export class ReplacedModal extends Component {
  render() {
    const { isOpen, onPlayHere } = this.props
    return (
      <div>
        <Modal isOpen={ isOpen } backdrop="static" keyboard={ false } className={this.props.className}>
          <ModalHeader>
            Your account is <strong>playing on another device</strong>
          </ModalHeader>
          <ModalBody>
            <p>
              Someone has just signed in to this GymRadio.com account somewhere else, so the music has stopped here.
              Each account plays in one location at a time.
            </p>
            <p>
              If this is your gym, sign in again to play here instead. Running more than one club?
              Contact us about a plan for multiple locations.
            </p>
            <div className="modal_buttonGroup">
              <Button color="primary" onClick={ onPlayHere } size="lg">
                <strong>Sign in and play here</strong>
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}
